import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import bgImage from './bg16.png';
import logo from './Logos.png';
import MD5 from "crypto-js/md5";
import ReCAPTCHA from 'react-google-recaptcha';

const siteKey = '6LdO3msrAAAAAEOUJb6wgbpbsfZKgPcjdA1mDwUW';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

console.log("🔧 ENV API_BASE_URL:", API_BASE_URL);

const Login = () => {
  const navigate = useNavigate();
  const [captchaValue, setCaptchaValue] = useState(null);
  const [formData, setFormData] = useState({
    emp_code: '',
    password: ''
  });
  const [responseMessage, setResponseMessage] = useState('');

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("📤 Submitting Login:", formData);

    try {
      const loginUrl = `${API_BASE_URL}login1`;
      console.log("➡️ Login URL:", loginUrl);

      const response = await fetch(loginUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData),
      });

      const result = await response.json();
      console.log("✅ Login Response:", result);

      if (!response.ok || !result.status) {
        if (result.error === 'Your Validity has expired.') {
          console.log("⚠️ Validity expired. Redirecting to change password 2");
          navigate(`/change_password2/${formData.emp_code}`);
          return;
        }
        console.warn("❌ Login failed:", result.error);
        setResponseMessage(result.error);
        return;
      }

      const token = result.token;
      const expirationTime = Date.now() + 7190000;

      localStorage.setItem('authToken', token);
      localStorage.setItem('exp', expirationTime);

      console.log("🔑 Token saved. Fetching profile...");

      const profileResponse = await fetch(`${API_BASE_URL}profile`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!profileResponse.ok) {
        console.error("❌ Error fetching profile");
        setResponseMessage('Error fetching profile');
        return;
      }

      const profileResult = await profileResponse.json();
      console.log("👤 Profile Response:", profileResult);

      const hashedPassword = MD5('adnet2008').toString();
      const getPassword = profileResult?.profile?.password;

      console.log("🔒 Default Hashed:", hashedPassword);
      console.log("🔑 User Password Hash:", getPassword);

      if (hashedPassword === getPassword) {
        console.log("🔁 Default password detected. Redirecting to change_password1");
        navigate('/change_password1');
        return;
      }

      if (profileResult.status) {
        localStorage.setItem('userProfile', JSON.stringify(profileResult.profile));
        console.log("🎯 Login successful. Redirecting to dashboard...");
        navigate('/dashboard');
      } else {
        console.warn("⚠️ Profile status false:", profileResult.message);
        setResponseMessage('Error fetching profile: ' + profileResult.message);
      }

    } catch (error) {
      console.error("💥 Error during login:", error.message);
      setResponseMessage('Error: ' + error.message);
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const uid = queryParams.get('uid');
    const pwd = queryParams.get('pwd');
    console.log("🔍 URL Params:", { uid, pwd });

    if (uid && pwd) {
      try {
        const decodedUid = atob(uid);
        const decodedPwd = pwd;
        console.log("🔓 Decoded UID:", decodedUid);
        console.log("🔓 Password:", decodedPwd);

        setFormData({ emp_code: decodedUid, password: decodedPwd });

        setTimeout(() => {
          console.log("🚀 Auto-login triggered");
          document.getElementById('autoLoginBtn')?.click();
        }, 50);
      } catch (error) {
        console.error("🚫 Error decoding URL params:", error);
      }
    }
  }, []);

  return (
    <main className="container-fluid" style={styles.mainContainer}>
      <div className="row" style={{ height: "100vh" }}>
        <div className="col-md-6 col-sm-12 position-relative" style={styles.imageContainer}>
          <img src={bgImage} alt="Background" style={styles.backgroundImage} />
          <div style={styles.overlay}></div>
        </div>

        <div className="col-md-6 col-sm-12 d-flex justify-content-center align-items-center" style={styles.formContainerWrapper}>
          <div style={styles.formContainer}>
            <div className="login-logo" style={styles.logoContainer}>
              <img src={logo} alt="Travel App" style={{ width: '100%' }} />
            </div>

            <center><p className="title" style={styles.title}>Travel App</p></center>
            <p style={styles.loginPrompt}>Please Login To Continue...</p>

            {responseMessage && (
              <div className="alert alert-danger" role="alert">
                {responseMessage}
              </div>
            )}

            <form onSubmit={handleSubmit} style={styles.form}>
              <input type="hidden" name="emp_code" value={formData.emp_code} />
              <input type="hidden" name="password" value={formData.password} />

              <div className="form-group" style={{ marginBottom: '15px' }}>
                <ReCAPTCHA sitekey={siteKey} onChange={handleCaptchaChange} />
              </div>

              <button type="submit" className="btn btn-block" id="autoLoginBtn" style={styles.loginButton}>
                Login
              </button>
            </form>

            <hr />
            <a className="forgot" href="#" style={styles.forgotLink}>
              Version: 1.0.2
            </a>
            <center>
              <p style={styles.signupText}>Developed by: Vijaya Diagnostic Centre</p>
            </center>
          </div>
        </div>
      </div>
    </main>
  );
};

const styles = {
  mainContainer: {
    background: "linear-gradient(to right, #6A82FB, #FC5C7D)",
    height: "100vh",
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    backgroundColor: "#ffffff",
  },
  backgroundImage: {
    maxHeight: "100%",
    width: "100%",
    objectFit: "cover",
    borderTopLeftRadius: "15px",
    borderBottomLeftRadius: "15px",
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderTopLeftRadius: "15px",
    borderBottomLeftRadius: "15px",
  },
  formContainerWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: "40px",
    backgroundColor: "#f7f7f7",
  },
  formContainer: {
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    padding: "40px",
    borderRadius: "15px",
    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
    width: "100%",
    maxWidth: "400px",
  },
  logoContainer: {
    textAlign: "center",
    marginBottom: "20px",
  },
  title: {
    fontSize: "28px",
    marginBottom: "20px",
    fontFamily: "'Poppins', sans-serif",
    color: "#333",
  },
  loginPrompt: {
    fontSize: "16px",
    marginBottom: "20px",
    color: "#555",
    textAlign: "center",
  },
  form: {
    textAlign: "left",
  },
  loginButton: {
    backgroundColor: "#6A82FB",
    border: "none",
    padding: "12px 0",
    fontSize: "18px",
    borderRadius: "5px",
    color: "#fff",
    cursor: "pointer",
    transition: "background-color 0.3s ease, transform 0.2s ease",
  },
  forgotLink: {
    display: "block",
    marginTop: "20px",
    textAlign: "center",
    color: "#6A82FB",
    textDecoration: "none",
  },
  signupText: {
    marginTop: "15px",
    color: "#666",
  },
};

export default Login;
